<!-- Header sticky -->
<header class="sticky top-0 z-30 bg-white border-b border-slate-100">
  <div class="mx-auto max-w-[480px] md:max-w-[1100px] px-6 md:px-6">
    <!-- Fila única: logo | acciones | menú -->
    <div class="h-16 grid grid-cols-[auto,1fr,auto] items-center">
      <!-- Logo (sin navegación) -->
      <button (click)="goToHome()" class="flex items-center gap-2 shrink-0 hover:opacity-80 transition-opacity" aria-label="Inicio">
        <img [src]="logoUrl" alt="Logo" class="h-10 w-auto" />
      </button>

      <!-- Menú -->
      <div class="relative justify-self-end">
        <button
          type="button"
          class="relative inline-flex items-center justify-center h-10 w-10 rounded-lg bg-neutral-gray-300 hover:bg-[#CBD5E1] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-300 transition-colors"
          (click)="toggleMenu()"
          aria-label="Menú">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M22.1998 12.0008C22.1998 12.7008 21.5998 13.2008 20.9998 13.2008H2.9998C2.2998 13.2008 1.7998 12.6008 1.7998 12.0008C1.7998 11.4008 2.3998 10.8008 2.9998 10.8008H20.9998C21.6998 10.8008 22.1998 11.3008 22.1998 12.0008ZM2.9998 7.20078H20.9998C21.6998 7.20078 22.1998 6.60078 22.1998 6.00078C22.1998 5.40078 21.6998 4.80078 20.9998 4.80078H2.9998C2.2998 4.80078 1.7998 5.30078 1.7998 6.00078C1.7998 6.70078 2.2998 7.20078 2.9998 7.20078ZM20.9998 16.8008H2.9998C2.2998 16.8008 1.7998 17.4008 1.7998 18.0008C1.7998 18.6008 2.3998 19.2008 2.9998 19.2008H20.9998C21.6998 19.2008 22.1998 18.6008 22.1998 18.0008C22.1998 17.4008 21.6998 16.8008 20.9998 16.8008Z" fill="#20202A"/>
</svg>

          <!-- Badge de notificaciones (solo si hay >0 y usuario autenticado) -->
          <ng-container *ngIf="isAuthenticated">
            <ng-container *ngIf="(notificationsService.unreadCount | async) as uc">
              <span *ngIf="uc > 0"
                    class="font-poppins absolute -top-1 -right-1 inline-flex items-center justify-center h-5 min-w-[18px] px-1 rounded-full bg-red-500 text-white text-[12px] font-semibold">
                {{ uc }}
              </span>
            </ng-container>
          </ng-container>
        </button>
      </div>
    </div>
  </div>
</header>

<!-- Side menu fuera del header para overlay correcto -->
<app-side-menu
  [isOpen]="isSideMenuOpen"
  (close)="closeSideMenu()">
</app-side-menu>
